import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {OrderStatus} from '@portbase/bezoekschip-service-typescriptmodels';

@Component({
    selector: 'app-order-status',
    templateUrl: './order-status.component.html',
    styleUrls: ['./order-status.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderStatusComponent {

  @Input()
  orderStatus: OrderStatus;
}
